<template>
  <dashboard />
</template>

<script>
import Dashboard from '@/components/organisms/Reviewer.vue'

export default {
  components:{
    dashboard: Dashboard
  }
};
</script>
